import { formatRegion } from "utils/formatRegion";
import { RootState } from "../../reducers";
import { CLIUser, Project } from "./types";
import { createSelector } from "reselect";

export const projectSelector = (state: RootState): Project | null =>
  state.projects.project;

export const isProjectLoadingSelector = (state: RootState): boolean =>
  state.projects.isProjectLoading;

export const isProjectCreatingSelector = (state: RootState): boolean =>
  state.projects.isProjectCreating;

export const isProjectUpdatingSelector = (state: RootState): boolean =>
  state.projects.isProjectUpdating;

export const isProjectDeletingSelector = (state: RootState): boolean =>
  state.projects.isProjectDeleting;

// export const organizationProjectsSelector = (
//   state: RootState
// ): TableProject[] | null =>
//   state.projects.organizationProjects?.map((project) => ({
//     ...project,
//     region: formatRegion(project.region)
//   })) || null;

const selectOrganizationProjects = (state: RootState) =>
  state.projects.organizationProjects;

export const organizationProjectsSelector = createSelector(
  [selectOrganizationProjects],
  (organizationProjects) => {
    if (!Array.isArray(organizationProjects)) {
      return null;
    }

    return organizationProjects.map((project) => ({
      ...project,
      region: formatRegion(project.region)
    }));
  }
);

export const areOrganizationProjectsLoadingSelector = (
  state: RootState
): boolean => state.projects.areOrganizationProjectsLoading;

export const cliUsersSelector = (state: RootState): CLIUser[] | null =>
  state.projects.cliUsers;

export const isCLIUserCreatingSelector = (state: RootState): boolean =>
  state.projects.isCLIUserCreating;

export const isCLIUserUpdatingSelector = (state: RootState): boolean =>
  state.projects.isCLIUserUpdating;

export const isCLIUserDeletingSelector = (state: RootState): boolean =>
  state.projects.isCLIUserDeleting;

export const areCLIUsersLoadingSelector = (state: RootState): boolean =>
  state.projects.areCLIUsersLoading;

export const isGroupToProjectAssigningSelector = (state: RootState): boolean =>
  state.projects.isGroupToProjectAssigning;

export const isGroupFromProjectRemovingSelector = (state: RootState): boolean =>
  state.projects.isGroupFromProjectRemoving;
